/**
 * @generated SignedSource<<498dcf095ccd2e5b09a7768f60f800b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTypeGroupHeader_issueTableGrouping$data = {
  readonly issueTypes: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly " $fragmentType": "issueTypeGroupHeader_issueTableGrouping";
};
export type issueTypeGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: issueTypeGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTypeGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueTypeGroupHeader_issueTableGrouping",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueTypes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlIssueTypeFieldValue"
};

(node as any).hash = "e0c64542f93e6d56ab8ae8cce997566d";

export default node;
